import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';
import { v4 as uuid } from "uuid";

import {
    performInvoiceAuditMatch,
    performInvoiceAuditMatchError
} from "../../../../constants/model-reducers/external/invoice/invoice/invoice-audit.settings";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, getLocalTimeZone } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    InvoiceAudit: [],
});

const initialState = defaultState();

export const invoiceAuditActions = {
    performAudit: (selectedResultRules, invoiceDetailsId) => async (dispatch, state) => {
        try {
            var invoiceMatchAudit = {
                    MatchAuditRules: selectedResultRules,
                    UserID: sessionStorage.getItem('UserID'),
                    InvoiceID: invoiceDetailsId,
                    BatchID: uuid()
            };

            var result = await httpPost('external/invoice/performAudit', invoiceMatchAudit);
            return result;
        }
        catch (e) {
            return e;
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case performInvoiceAuditMatch: {
            return {
                ...state,
                InvoiceAudit: action.InvoiceAudit
            };
        }
        case performInvoiceAuditMatchError: {
            return {
                ...state,
                isperformInvoiceAuditMatchError: action.isperformInvoiceAuditMatchError
            }
        }
        default:
            return state;
    }
}